import { useState, useCallback } from "react";
import { notification } from "antd";
import { GetUsers_getUsers } from "../__generated__/gql-types/GetUsers";
import { Roles } from "../__generated__/gql-types/globalTypes";
import UseGetUsersWithFilters, { UserFilters, UsersWithFiltersResponse } from "../api/useGetUsersWithFilters";
import UseDeleteUser from "../api/useDeleteUser";

export const useUsersWithSearch = () => {
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<GetUsers_getUsers[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const getUsersWithFilters = UseGetUsersWithFilters();
  const deleteUserMutation = UseDeleteUser();

  const fetchUsers = useCallback(async (filters?: UserFilters) => {
    setLoading(true);
    try {
      const response: UsersWithFiltersResponse = await getUsersWithFilters(filters);
      
      setUsers(response.users || []);
      setTotalCount(response.totalCount);
      setHasMore(response.hasMore);
      setCurrentPage(response.currentPage);
      setTotalPages(response.totalPages);
      
      setLoading(false);
      return response;
    } catch (error: any) {
      setLoading(false);
      notification["error"]({
        message: "Error",
        description: "La información no pudo ser cargada, por favor notifica éste error!",
        placement: "top",
        duration: 3,
      });
      throw new Error(error);
    }
  }, [getUsersWithFilters]);

  const searchUsers = useCallback(async (searchTerm?: string, role?: Roles, page: number = 1, limit: number = 10) => {
    const offset = (page - 1) * limit;
    
    const filters: UserFilters = {
      search: searchTerm || undefined,
      role: role || undefined,
      limit,
      offset,
    };

    return await fetchUsers(filters);
  }, [fetchUsers]);

  const loadInitialUsers = useCallback(async () => {
    return await fetchUsers();
  }, [fetchUsers]);

  const deleteUser = async (idUser: string) => {
    setLoading(true);
    try {
      const response = await deleteUserMutation({
        deleteUserId: idUser,
      });
      if (response.data) {
        notification["success"]({
          message: "Eliminación Exitosa",
          description: "El usuario fue eliminado con exito!",
          placement: "top",
          duration: 3,
        });
        
        await loadInitialUsers();
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      notification["error"]({
        message: "Eliminación Erronea",
        description: "El usuario no pudo ser eliminado!",
        placement: "top",
        duration: 3,
      });
    }
  };

  return {
    loading,
    users,
    totalCount,
    hasMore,
    currentPage,
    totalPages,
    searchUsers,
    loadInitialUsers,
    deleteUser,
  };
};
